import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'app-motor-car-en-v2',
    templateUrl: './motor-car-en-v2.component.html',
    styleUrls: ['./motor-car-en-v2.component.css'],
    standalone: false
})
export class MotorCarEnV2Component implements OnInit, OnChanges {
  @Input() printActive: boolean
  @Input() returnData: any
  @Input() isSinglePageReturn: boolean
  motorCar = [];
  capitalPartnershipFirm = [];
  businessCapitalExceptDirector = [];
  
  motorCarTypeArray: any[] = [
    {
      type: 'motorcycle',
      description: 'Motorcycle'
    },
    {
      type: 'car_micro_zeep',
      description: 'Car, Microbus, Zeep'
    },
    {
      type: 'any_other',
      description: 'Any other'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.motorCar = [];

    this.returnData?.headSummery?.assetsAndLiabilities?.forEach(item=>{
      if(item.firstSubTypeKey === 'motor_car'){
        this.motorCar = this.motorCar.concat(item.detailsOfAL)
      }
    })
  }

  getMotorcarTypeDescription(description: string): string {
    return this.motorCarTypeArray.find(type => type.type === description)?.description;
  }

}
